const moneda = 's/ ';

export default moneda;
